import { NgModule } from '@angular/core';
import { LibConnectAccountsV2IconComponent } from './lib-connect-accounts-v2-icon.component';

@NgModule({
  declarations: [LibConnectAccountsV2IconComponent],
  imports: [],
  exports: [LibConnectAccountsV2IconComponent],
})
export class LibConnectAccountsV2IconModule {}
